import {queryCampaignType} from 'js/graphql/queries/queryCampaignType';
import {queryInvitedCreators} from 'js/graphql/queries/queryInvitedCreators';
import {getManualInvitedTargetingCreators} from 'js/graphql/queries/getManualInvitedTargetingCreators';

import React, {Component} from 'react';
import { FeatureFlag } from 'react-launch-darkly';

class InvitedCreatorsV1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaignType: '',
            userHandleList: [],
            manualInvitedCreators: []
        };
    }

    componentDidMount() {
        this.getCampaignType();
        this.getCreators();
        this.getManualInvitedTargetingCreators();
    }

    getCampaignType() {
        queryCampaignType(this.props.campaignId)
            .then(campaignType => {
                this.setState({campaignType});
            })
            .catch(error => {
                console.error(error);
                throw new Error(error);
            });
    }

    getCreators() {
        queryInvitedCreators(this.props.campaignId)
            .then(creators => {
                this.setUserHandleList(creators || []);
            })
            .catch(error => {
                console.error(error);
                throw new Error(error);
            });
    }

    getManualInvitedTargetingCreators() {
        getManualInvitedTargetingCreators(this.props.campaignId)
            .then(creators => {
                this.setState({manualInvitedCreators: creators || []});
            })
            .catch(error => {
                console.error(error);
                throw new Error(error);
            });
    }

    setUserHandleList(creators) {
        this.setState({userHandleList: []});

        if (creators.length > 0) {
            const userHandleList = creators
                .map(creator => {
                    if (this.state.campaignType === 'instagram' && creator.instagramMetadata[0]) {
                        return {
                            id: creator.id,
                            handle: creator.instagramMetadata[0].userHandle,
                            link: `https://www.instagram.com/${creator.instagramMetadata[0].userHandle}/`
                        };
                    }
                    if (this.state.campaignType === 'tiktok' && creator.tiktokMetadata) {
                        return {
                            id: creator.id,
                            handle: creator.tiktokMetadata.userHandle,
                            link: `https://www.tiktok.com/@${creator.tiktokMetadata.userHandle}`
                        };
                    }
                })
                .filter(Boolean);

            this.setState({userHandleList});
        }
    }

    render() {
        return (
            <div className="invited-creators">
                <div className="invited-creators__creators">
                    {this.state.userHandleList.length > 0 &&
                        this.state.userHandleList.map(userHandle => (
                            <a
                                key={userHandle.id}
                                href={userHandle.link}
                                target="_blank"
                                rel="noreferrer"
                                className="invited-creators__creator"
                            >
                                @{userHandle.handle}
                            </a>
                        ))}

                    {this.state.manualInvitedCreators.length > 0 &&
                        this.state.manualInvitedCreators.map((creator, i) => (
                            <a
                                key={i}
                                href={`mailto:${creator}`}
                                target="_blank"
                                rel="noreferrer"
                                className="invited-creators__manual-creator"
                            >
                                {creator}
                            </a>
                        ))}
                </div>
            </div>
        );
    }
}

class InvitedCreatorsV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaignType: '',
            userHandleList: [],
            manualInvitedCreators: []
        };
    }

    componentDidMount() {
        this.getCampaignType();
        this.getCreators();
        this.getManualInvitedTargetingCreators();
    }

    getCampaignType() {
        queryCampaignType(this.props.campaignId)
            .then(campaignType => {
                this.setState({campaignType});
            })
            .catch(error => {
                console.error(error);
                throw new Error(error);
            });
    }

    getCreators() {
        queryInvitedCreators(this.props.campaignId)
            .then(creators => {
                this.setUserHandleList(creators || []);
            })
            .catch(error => {
                console.error(error);
                throw new Error(error);
            });
    }

    getManualInvitedTargetingCreators() {
        getManualInvitedTargetingCreators(this.props.campaignId)
            .then(creators => {
                this.setState({manualInvitedCreators: creators || []});
            })
            .catch(error => {
                console.error(error);
                throw new Error(error);
            });
    }

    setUserHandleList(creators) {
        this.setState({userHandleList: []});

        if (creators.length > 0) {
            const userHandleList = creators
                .map(creator => {
                    if (this.state.campaignType === 'instagram' && creator.instagramMetadata[0]) {
                        return {
                            id: creator.id,
                            handle: creator.instagramMetadata[0].userHandle,
                            link: `https://www.instagram.com/${creator.instagramMetadata[0].userHandle}/`
                        };
                    }
                    if (this.state.campaignType === 'tiktok' && creator.tiktokMetadata) {
                        return {
                            id: creator.id,
                            handle: creator.tiktokMetadata.userHandle,
                            link: `https://www.tiktok.com/@${creator.tiktokMetadata.userHandle}`
                        };
                    }
                })
                .filter(Boolean);

            this.setState({userHandleList});
        }
    }

    render() {
        return (
            <div className="invited-creators-section">
                {this.state.userHandleList.length > 0 &&
                    this.state.userHandleList.map(userHandle => (
                        <a
                            key={userHandle.id}
                            href={userHandle.link}
                            target="_blank"
                            rel="noreferrer"
                        >
                            @{userHandle.handle}
                        </a>
                    ))}

                {this.state.manualInvitedCreators.length > 0 &&
                    this.state.manualInvitedCreators.map((creator, i) => (
                        <a
                            key={i}
                            href={`mailto:${creator}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {creator}
                        </a>
                    ))}
                
                {this.state.userHandleList.length === 0 && this.state.manualInvitedCreators.length === 0 && (
                    <p>N/A</p>
                )}
            </div>
        );
    }
}

const InvitedCreators = (props) => (
    <FeatureFlag
        flagKey="order-form-v2-enabled"
        renderFeatureCallback={flag =>
            flag
                ? <InvitedCreatorsV2 {...props} />
                : <InvitedCreatorsV1 {...props} />
        }
        renderDefaultCallback={() => <InvitedCreatorsV1 {...props} />}
    />
);

export default InvitedCreators;


// WEBPACK FOOTER //
// ./components/verify_receipt_common/invited_creators.js